var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof eysenseFooter !== "undefined") return resolve();
	__webpack_require__.l("https://experience.ey.com/fabric-eysense-footer/remoteEntry.js?v=71af762b8311f7921d27222c8e66066f038dd6b7", (event) => {
		if(typeof eysenseFooter !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "eysenseFooter");
}).then(() => (eysenseFooter));